import React from 'react';
import { pillars } from '../data/pillars';
import { OFFER_ANCHOR } from './constants';
export function PillarsSection() {
  return <section className="border-y border-pf-creamDark bg-pf-cream px-3 py-3 sm:px-4 sm:py-4" data-id="element-144" data-mp="285txt39qgw6y">
      <div className="mx-auto max-w-4xl" data-id="element-145" data-mp="23dahvznkpoyz">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-146" data-mp="1yfih0g4yasin">
          This Isn’t Just About Having More Exercises
        </h2>
        <p className="mb-1.5 text-center font-display text-[13px] font-extrabold uppercase text-pf-coral sm:text-xl" data-id="element-147" data-mp="1te2vyo2rwm09">
          It’s About Having a Complete Coaching System.
        </p>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2 lg:grid-cols-4" data-id="element-148" data-mp="1khtvd6327hcj">
          {pillars.map(pillar => <a key={pillar.title} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-pf-creamDark bg-white p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-pf-coral sm:p-3" data-id="element-149" data-mp="1fizbe0tcvmqu">
              <h3 className="font-display text-[13px] font-extrabold uppercase leading-tight text-pf-navy sm:text-base" data-id="element-150" data-mp="27bhs5pb3vu3">
                {pillar.emoji} {pillar.title}
              </h3>
              <p className="mt-0.5 text-[12px] font-medium leading-snug text-pf-ink sm:text-sm" data-id="element-151" data-mp="3ohe953yw1vln">
                {pillar.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}